module.exports = __webpack_public_path__ + "getimgai-1-fe522e3e584731e9a6d1d85dfe612d6c.webp";